export default __webpack_public_path__ + "static/media/about-me-mihai.32eac908.png";